export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
      <h1 className="font-heading text-3xl sm:text-4xl text-stone-900">Terms of Service</h1>
      <p className="text-stone-600 mt-3">By placing an order on MyZippyKart, you agree to receive the products as described in your cart. Prices are inclusive of applicable taxes unless stated otherwise.</p>
      <h2 className="font-heading text-2xl text-stone-900 mt-8">Cancellations</h2>
      <p className="text-stone-600 mt-2">You can cancel before the order is marked Out for Delivery. Contact us via WhatsApp for fastest support.</p>
      <h2 className="font-heading text-2xl text-stone-900 mt-8">Returns</h2>
      <p className="text-stone-600 mt-2">If the product is damaged or incorrect, reject the delivery and you will not be charged.</p>
    </div>
  );
}
